// src/guide/compte/guide_compte_utilisateurs.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_compte_utilisateurs(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.compte.barreNavigation.titre,
    translations.compte.barreNavigation.texte,
    `#${(document.getElementById("fils_barreNavigation").parentElement.id =
      "barreNavigation")}`,
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.utilisateurs.titre,
    translations.compte.utilisateurs.utilisateurs.texte,
    "#utilisateurs",
    ""
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.texte,
    "#ajouter_utilisateur",
    "bottom"
  );

  tour.start();
}
